exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Labels{display:flex;flex-direction:row;align-items:flex-start;margin-top:5px}.Labels .label_title{color:#00adff;text-decoration:underline;cursor:pointer}.Labels .items{display:flex;flex-wrap:wrap;align-items:center;margin-left:5px}.Labels .items .item_label{font-size:12px;padding:2px 5px;border-radius:2px;background:gray;margin-left:2px;margin-right:2px;color:#fff;font-weight:500;min-width:50px;min-height:21px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/style.scss
// module id = 2503
// module chunks = 0